import '../styles/cover.scss';
import coverDesktop from '../assets/cover-desktop.svg';

export const Cover = () => {
  return (
    <div className='cover'>
    <div className='cover-container'>
        <div className='cover-text'>
            <h1 data-aos="fade-right" data-aos-delay="700" data-aos-duration="1000" data-aos-easing="ease-out">
                Conectamos personas, transformamos equipos
            </h1>
            <p data-aos="fade-right" data-aos-delay="900" data-aos-duration="1200" data-aos-easing="ease-out">
                En Serendipia, transformamos el proceso de selección en una experiencia personalizada y efectiva
            </p>
            <a  className='button' data-aos="fade-right" data-aos-delay="1100" data-aos-duration="1200" data-aos-easing="ease-out" href='/busquedas'>
                Explorá ofertas laborales
            </a>
        </div>
        <div data-aos="zoom-out" data-aos-delay="1200" data-aos-duration="1000" data-aos-easing="ease-out"  data-aos-offset="0" className='cover-img'>
            <img src={coverDesktop} alt="Serendipia cover" />
        </div>
    </div>
</div>

  );
}
